export default "__VITE_ASSET__DiY6LWY2__"